import React from 'react';
import img from "../../assets/images/nv.png";
const BrandLogo = ({brandImg}) => {
    return (
        <div className="col-md-2  col-3">
            <div className="brand-logo-card">
        
                <img src={brandImg?.img?.url} className="img-fluid" alt="" />
            </div>
        </div>
    );
};

export default BrandLogo;